/**
 * @generated SignedSource<<38e3cbb2452784d61fdf3005dc3702a1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ScreenersParticipantIncentivizedTypeChoices = "CA" | "EX" | "PT" | "%future added value";
export type ScreenersRecruitStatusChoices = "F" | "NS" | "P" | "S" | "%future added value";
export type ScreenersRespondentMasterStatusChoices = "A" | "CS" | "D" | "IW" | "NR" | "NS" | "OQ" | "RT" | "RW" | "S" | "SS" | "T" | "%future added value";
export type RewardParticipantInput = {
  clientMutationId?: string | null;
  participantId: string;
};
export type Cells_RewardParticipant_Mutation$variables = {
  input: RewardParticipantInput;
};
export type Cells_RewardParticipant_Mutation$data = {
  readonly rewardParticipant: {
    readonly participant: {
      readonly id: string;
      readonly incentivized: boolean;
      readonly incentivizedAmount: string | null;
      readonly incentivizedOn: any | null;
      readonly incentivizedPointAmount: number | null;
      readonly incentivizedType: ScreenersParticipantIncentivizedTypeChoices | null;
    } | null;
    readonly respondent: {
      readonly masterStatus: ScreenersRespondentMasterStatusChoices | null;
    } | null;
    readonly study: {
      readonly completeCount: number | null;
      readonly goalPaidForCount: number | null;
      readonly needsPaymentCount: number | null;
      readonly recruits: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly fee: any | null;
            readonly goalPaidForCount: number | null;
            readonly incentive: string | null;
            readonly name: string | null;
            readonly rewardedCount: number | null;
            readonly status: ScreenersRecruitStatusChoices;
            readonly totalDeposits: any | null;
            readonly totalPayouts: any | null;
            readonly totalRefunds: any | null;
            readonly totalRefundsDue: any | null;
          } | null;
        } | null>;
      };
      readonly rewardedCount: number | null;
      readonly totalDeposits: any | null;
      readonly totalFees: any | null;
      readonly totalIncentives: any | null;
      readonly totalPayouts: any | null;
      readonly totalPerParticipantCosts: any | null;
      readonly totalRefunds: any | null;
      readonly totalRefundsDue: any | null;
    } | null;
  } | null;
};
export type Cells_RewardParticipant_Mutation = {
  response: Cells_RewardParticipant_Mutation$data;
  variables: Cells_RewardParticipant_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "ParticipantNode",
  "kind": "LinkedField",
  "name": "participant",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "incentivized",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "incentivizedAmount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "incentivizedOn",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "incentivizedType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "incentivizedPointAmount",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "needsPaymentCount",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "completeCount",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rewardedCount",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "goalPaidForCount",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalIncentives",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalFees",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalPerParticipantCosts",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalDeposits",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalPayouts",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalRefunds",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalRefundsDue",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "incentive",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fee",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "masterStatus",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Cells_RewardParticipant_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RewardParticipantPayload",
        "kind": "LinkedField",
        "name": "rewardParticipant",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "StudyNode",
            "kind": "LinkedField",
            "name": "study",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "RecruitNodeConnection",
                "kind": "LinkedField",
                "name": "recruits",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RecruitNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RecruitNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v15/*: any*/),
                          (v6/*: any*/),
                          (v7/*: any*/),
                          (v16/*: any*/),
                          (v17/*: any*/),
                          (v11/*: any*/),
                          (v12/*: any*/),
                          (v13/*: any*/),
                          (v14/*: any*/),
                          (v18/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RespondentNode",
            "kind": "LinkedField",
            "name": "respondent",
            "plural": false,
            "selections": [
              (v19/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Cells_RewardParticipant_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RewardParticipantPayload",
        "kind": "LinkedField",
        "name": "rewardParticipant",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "StudyNode",
            "kind": "LinkedField",
            "name": "study",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "RecruitNodeConnection",
                "kind": "LinkedField",
                "name": "recruits",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RecruitNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RecruitNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v15/*: any*/),
                          (v6/*: any*/),
                          (v7/*: any*/),
                          (v16/*: any*/),
                          (v17/*: any*/),
                          (v11/*: any*/),
                          (v12/*: any*/),
                          (v13/*: any*/),
                          (v14/*: any*/),
                          (v18/*: any*/),
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RespondentNode",
            "kind": "LinkedField",
            "name": "respondent",
            "plural": false,
            "selections": [
              (v19/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "689c5ac25a7a296fbff9ef4a97679520",
    "id": null,
    "metadata": {},
    "name": "Cells_RewardParticipant_Mutation",
    "operationKind": "mutation",
    "text": "mutation Cells_RewardParticipant_Mutation(\n  $input: RewardParticipantInput!\n) {\n  rewardParticipant(input: $input) {\n    participant {\n      id\n      incentivized\n      incentivizedAmount\n      incentivizedOn\n      incentivizedType\n      incentivizedPointAmount\n    }\n    study {\n      needsPaymentCount\n      completeCount\n      rewardedCount\n      goalPaidForCount\n      totalIncentives\n      totalFees\n      totalPerParticipantCosts\n      totalDeposits\n      totalPayouts\n      totalRefunds\n      totalRefundsDue\n      recruits {\n        edges {\n          node {\n            name\n            rewardedCount\n            goalPaidForCount\n            incentive\n            fee\n            totalDeposits\n            totalPayouts\n            totalRefunds\n            totalRefundsDue\n            status\n            id\n          }\n        }\n      }\n      id\n    }\n    respondent {\n      masterStatus\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6fcf4d04db315530aa148b7ef231d912";

export default node;
